module.exports = __webpack_public_path__ + "img/SB_logo.a7d59448.png";